import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import createHistory from "history/createBrowserHistory";
import ViewChooser from "./components/Common/ViewChooser";
import Header from "./components/Common/Header";
import helpers, { getParams, statusUpdater, getDescriptors } from "wvus-sponsorship-engine";
import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { triggerSponsorshipAnalyticsEvent } from "./utils/analytics-helpers.js";
import { removeBodyClass } from "./utils/helpers";
import {
  faClock,
  faAngleRight,
  faSearch,
  faSync,
  faSlidersH,
  faAngleUp,
  faArrowUp,
  faAngleDown,
  faVolumeUp,
  faVolumeOff,
  faPause,
  faPlay,
  faCheckCircle,
  faInfoCircle,
  faTimes,
  faTimesCircle,
  faExclamationCircle,
} from "@fortawesome/free-solid-svg-icons";
import { faCopy } from "@fortawesome/free-regular-svg-icons";
//create font-awesome library
library.add(
  faClock,
  faAngleRight,
  faSearch,
  faSync,
  faSlidersH,
  faAngleUp,
  faArrowUp,
  faAngleDown,
  faVolumeOff,
  faVolumeUp,
  faPause,
  faPlay,
  faCheckCircle,
  faCopy,
  faInfoCircle,
  faTimes,
  faTimesCircle,
  faExclamationCircle
);

const history = createHistory({ basename: window.location.pathname });

// Get the current location.
const location = history.location;
// Listen for changes to the current location.
// const unlisten = history.listen((location, action) => {
//   // location is an object like window.location
//   console.log("unlisten: ", action, location.pathname, location.state)
// })

export class App extends Component {
  constructor(props) {
    super(props);

    const getFailoverMode = () => {
      if (window.WVUS_SPONSORSHIP_FAILOVER) {
        if (window.WVUS_SPONSORSHIP_FAILOVER.failover_mode === "1") {
          return {
            failover: true,
            callbackURL: window.WVUS_SPONSORSHIP_FAILOVER.failover_callback_url,
          };
        } else {
          return {
            failover: false,
            callbackURL: null,
          };
        }
      } else {
        return {
          failover: false,
          callbackURL: null,
        };
      }
    };

    this.showMoreInitialState = {
      itemsToShow: 19,
      currentItemsShown: 19,
      showLoadMore: true,
      descriptorIndex: null,
      descriptorsReceived: true,
      descriptorIndexArray: [],
    };

    this.state = {
      device: "mobile",
      desktop: "(min-width: 768px)",
      tablet: "(max-width: 767px) and (min-width: 480px)",
      mobile: "(max-width: 479px) and (min-width: 320px)",
      singleChildView: false,
      childId: "",
      sponsorshipMonthlyPrice: 39,
      ...this.showMoreInitialState,
      gridVars: {},
      gridVarsReceived: false,
      backLink: null,
      backButton: null,
      gridWasActive: null,
      lastSearchKeyObj: {},
      tabSelected: "detail",
      take: 108,
      curatedSearchSelected: "longest-waiting",
      resetFiltersDisabled: true,
      lastSearchKeyUpdated: false,
      activeToolTipIndex: 0,
      reservePool: null,
      projectIdentifiers: [],
      projectDescription: null,
      ADPSearch: false,
      failover: getFailoverMode().failover,
      failoverCallbackUrl: getFailoverMode().callbackURL,
      showDeepLinkError: false,
      child_unavailable: {
        child_unavailable_search_method: null,
        child_unavailable_search: false,
        child_locked: false,
        child_unavailable_searchTerms: [],
      },
      check_child_available: false,
      message: {},
      loading_class: "loading-container",
      appConfigs: window.wv_rcds || {},
    };

    this.handleResize();
    this.checkChildLocked = this.checkChildLocked.bind(this);
    this.renderHeader = this.renderHeader.bind(this);
    this.handleResize = this.handleResize.bind(this);
    this.handleWindowSizeChange = this.handleWindowSizeChange.bind(this);
    this.showMore = this.showMore.bind(this);
    this.renderShowMore = this.renderShowMore.bind(this);
    this.resetShowMore = this.resetShowMore.bind(this);
    this.handleChildDetailClick = this.handleChildDetailClick.bind(this);
    this.handleBackButton = this.handleBackButton.bind(this);
    this.resetGridCalc = this.resetGridCalc.bind(this);
    this.calculateGrid = this.calculateGrid.bind(this);
    this.handleHistory = this.handleHistory.bind(this);
    this.setGridWasActive = this.setGridWasActive.bind(this);
    this.lastSearchKey = this.lastSearchKey.bind(this);
    this.searchMethodSelector = this.searchMethodSelector.bind(this);
    this.setSelectedValue = this.setSelectedValue.bind(this);
    this.enableClearAll = this.enableClearAll.bind(this);
    this.updatelastSearchKeyStatus = this.updatelastSearchKeyStatus.bind(this);
    this.setToolTip = this.setToolTip.bind(this);
    this.fireAnalyticsEvents = this.fireAnalyticsEvents.bind(this);
    this.toggleErrorMessage = this.toggleErrorMessage.bind(this);
    this.toggleDetailView = this.toggleDetailView.bind(this);
    this.animateGrid = this.animateGrid.bind(this);
    this.setADPStatus = this.setADPStatus.bind(this);
  }

  setADPStatus(bool, projectName) {
    this.setState({ ADPSearch: bool, projectDescription: projectName });
  }

  animateGrid(reset = false) {
    if (reset) {
      this.setState({
        loading_class: "loading-container",
      });
    } else {
      this.setState({
        loading_class: "loading-container--loaded",
      });
    }
  }

  setToolTip(index) {
    this.setState({ activeToolTipIndex: index });
  }

  setSelectedValue(value) {
    this.setState({
      curatedSearchSelected: value,
    });
  }

  searchMethodSelector(tab, activeTab) {
    this.setState({
      tabSelected: tab,
    });
  }

  updatelastSearchKeyStatus(bool, callback = () => {}) {
    this.setState({ lastSearchKeyUpdated: bool }, () => {
      callback();
    });
  }

  lastSearchKey(params, callback = () => {}) {
    this.setState({ lastSearchKeyObj: params }, () => {
      //this will maintain the reservepool on clear all.
      if (Object.keys(this.state.lastSearchKeyObj).length > 1) {
        this.enableClearAll(true);
      }
      callback();
    });
  }

  fireAnalyticsEvents(activeView, props = {}) {
    document.addEventListener("gtmIsReady", function (e) {
      if (e.detail == "sponsorshipApp") {
        triggerSponsorshipAnalyticsEvent("navigation.sponsorship", {
          itemId: activeView === "childDetail" ? props.childId : null,
          backLink: activeView === "childDetail" ? props.backLink : null,
          view: activeView,
        });
      }
    });
    if (typeof window.wvus_gtmWasReady !== "undefined" && window.wvus_gtmWasReady) {
      triggerSponsorshipAnalyticsEvent("navigation.sponsorship", {
        itemId: activeView === "childDetail" ? props.childId : null,
        backLink: activeView === "childDetail" ? props.backLink : null,
        view: activeView,
      });
    }
  }

  setGridWasActive(component) {
    this.setState({ gridWasActive: component });
  }

  handleFindAvailableChild(bool) {
    this.setState({ check_child_available: bool });
  }

  checkChildLocked(bool, childId, method) {
    //this.setState({ ...this.state, child_unavailable: {child_locked: bool }});
    if (bool) {
      let searchTerm = "";
      switch (method) {
        //set gender to M or F instead of Female/Male
        case "gender":
          searchTerm = this.props.child[childId][method].charAt(0);
          break;
        //set country to an array for RCDS
        case "countryCodes":
          searchTerm = [this.props.child[childId].countryCode];
          break;
        default:
          searchTerm = this.props.child[childId][method];
      }
      this.setState({
        child_unavailable: {
          ...this.state.child_unavailable,
          child_unavailable_searchTerms: [[method], searchTerm],
        },
      });
    }
  }

  handleDeepLinks() {
    const urlParams = new URLSearchParams(window.location.search);
    const itemId = urlParams.get("childItem");
    const backlink = urlParams.get("backLink") || null;
    const reservationReferenceIdentifier = urlParams.get("reservationReferenceIdentifier");
    let findAvailableChild = urlParams.get("findAvailableChild") || null;
    const qsProjectIndentifiers = urlParams.get("projectIdentifiers") || urlParams.get("CP");
    let arrayQsProjectIndentifiers = null;
    qsProjectIndentifiers
      ? (arrayQsProjectIndentifiers = qsProjectIndentifiers.split(","))
      : (arrayQsProjectIndentifiers = undefined);

    const tab = urlParams.get("tab") || '';
    const orphans = urlParams.get("orphans") || '';
    const longestWaiting = urlParams.get("longestWaiting") || '';
    const highRisk = urlParams.get("highRisk") || '';
    const hungerCrisis = urlParams.get("hungerCrisis") || '';

    // set initial tab if search by need
    if (tab.toLowerCase() === "searchbyneed") {
      this.setState({ tabSelected: 'curated' });
    }

    // set currated tab if present
    if (orphans.toLowerCase() === "true") {
      this.setState({ curatedSearchSelected: "orphan" });
    } else if (longestWaiting.toLowerCase() === "true") {
      this.setState({ curatedSearchSelected: "longest-waiting" });
    } else if (highRisk.toLowerCase() === "true") {
      this.setState({ curatedSearchSelected: "high-risk" });
    } else if (hungerCrisis.toLowerCase() === "true") {
      this.setState({ curatedSearchSelected: "hunger" });
    }

    //force adp
    if (window.wv_rcds && window.wv_rcds.settings && window.wv_rcds.settings.projectIdentifiers.length > 0) {
      this.setState({
        projectIdentifiers: window.wv_rcds.settings.projectIdentifiers,
      });
    } else if (this.state.projectIdentifiers.length < 1 && qsProjectIndentifiers && qsProjectIndentifiers.length > 0) {
      console.log("qsProjectIndentifiers:", arrayQsProjectIndentifiers);
      this.setState({
        projectIdentifiers: arrayQsProjectIndentifiers,
      });
    }

    if (typeof variable_name !== "undefined" && window.wv_rcds.sponsorshipEnv.reserve_pool.length > 0) {
      var isreservepool = true;
    }

    //force reserve_pool
    if (window.wv_rcds && window.wv_rcds.sponsorshipEnv && isreservepool) {
      this.setState({
        reservePool: window.wv_rcds.sponsorshipEnv.reserve_pool,
      });
    } else if (
      this.state.reservePool === null &&
      reservationReferenceIdentifier &&
      reservationReferenceIdentifier.length > 0
    ) {
      this.setState({
        reservePool: reservationReferenceIdentifier,
      });
    }

    if (findAvailableChild === "country") {
      findAvailableChild = "countryCodes";
    }

    if (itemId && itemId.length > 0) {
      this.setState({
        singleChildView: true,
        childId: itemId,
        backLink: backlink,
        descriptorIndex: Math.floor(Math.random() * this.props.descriptors.length),
      });

      for (var key of urlParams.keys()) {
        if (key === "findAvailableChild") {
          this.handleFindAvailableChild(true);
          if (findAvailableChild && findAvailableChild.length > 0) {
            this.setState({
              child_unavailable: {
                ...this.state.child_unavailable,
                child_unavailable_search_method: findAvailableChild,
                child_unavailable_search: true,
              },
            });
            // console.log(this.state);
          }
        }
      }
    }
  }

  enableClearAll(bool) {
    this.setState({ resetFiltersDisabled: !bool });
  }

  UNSAFE_componentWillMount() {
    this.handleDeepLinks();
  }

  componentDidMount() {
    this.generateChildDescriptorsNumber(this.state.itemsToShow);
    let mqlLarge = window.matchMedia(this.state.desktop);
    this.handleWindowSizeChange(mqlLarge, "desktop");
    if (this.state.singleChildView === false) {
      this.fireAnalyticsEvents("grid");
    }
    // const state = this.state.singleChildView;
    history.listen((location, action) => {
      // console.log(`The current URL is ${location.pathname}${location.search}${location.hash}`);
      // console.log(`The last navigation action was ${action}`);
      // console.log(`The current URL is ${location.pathname}`);
      //handle browser buttons
      if (
        action === "POP" &&
        this.state.backLink === "grid" &&
        this.state.singleChildView === true &&
        this.state.gridWasActive === true
      ) {
        this.setState({ singleChildView: false });
        this.resetGridCalc();
        history.replace("/", { ...this.state });
        this.fireAnalyticsEvents("grid");
        return true;
      }
      if (action === "POP" && this.state.singleChildView === false) {
        this.handleChildDetailClick("", this.state.childId, this.state.descriptorIndex);
        return true;
      }
    });
  }

  generateChildDescriptorsNumber(increment = 1, loadMore = false) {
    const arr = this.state.descriptorIndexArray.slice();
    for (let i = 0; i <= increment; i++) {
      arr.push(Math.floor(Math.random() * this.props.descriptors.length));
    }
    if (loadMore === false) {
      this.setState((prevState) => ({ descriptorIndexArray: arr }));
      return;
    }
    return arr;
  }

  showMore(increment = 20) {
    this.resetGridCalc();
    if (this.state.itemsToShow < this.props.submissions.children.response.length) {
      this.setState(
        (prevState) => ({
          itemsToShow: prevState.itemsToShow + increment,
          currentItemsShown: prevState.currentItemsShown + increment,
          descriptorIndexArray: this.generateChildDescriptorsNumber(increment, true),
        }),
        //after state is updated, use callback to get new state and determine if the load more button should be shown.
        () => {
          this.renderShowMore();
        }
      );
    }
  }

  handleHistory(path, state) {
    history.push(path, state);
  }

  handleChildDetailClick(e, id = null, descriptorIndex = null) {
    if (e.preventDefault) {
      e.preventDefault();
    }
    //console.log("handleChildDetailClick", descriptorIndex);
    this.setState(
      {
        singleChildView: true,
        childId: id,
        backLink: "grid",
        descriptorIndex: descriptorIndex,
        showDeepLinkError: false,
      },
      () => {
        this.handleHistory(`?childItem=${this.state.childId}&backLink=grid`, { ...this.state });
      }
    );
  }

  changeView(bool) {
    this.setState({
      singleChildView: true,
    });
  }

  handleBackButton(e = null) {
    this.props.statusUpdater("EDITING");
    if (this.state.backLink === "grid" && this.state.gridWasActive === true) {
      history.goBack();
      this.handleHistory(`/`, { ...this.state });
    } else {
      this.setState((prevState) => ({ singleChildView: !prevState.singleChildView }));
      this.handleHistory(`/`, { ...this.state });
      ("grid");
      this.fireAnalyticsEvents("grid");
    }
  }

  renderShowMore() {
    if (
      this.state.itemsToShow >= this.props.submissions.children.response.length ||
      this.state.currentItemsShown >= this.props.submissions.children.response.length - 5
    ) {
      this.setState({ showLoadMore: false });
    } else {
      this.setState({ showLoadMore: true });
    }
  }

  resetShowMore() {
    this.setState({
      itemsToShow: this.showMoreInitialState.itemsToShow,
      currentItemsShown: this.showMoreInitialState.currentItemsShown,
      showLoadMore: this.showMoreInitialState.showLoadMore,
    });
  }

  renderHeader(props) {
    if (props.device === "desktop" && this.state.appConfigs.settings.showDesktopHeader !== "false") {
      return (
        <Header
          parentCssClass=""
          childCssClass="container"
          title="Sponsor a child with World Vision"
          text={[
            "Sponsoring a child is a personal way to show God's love to a child in need. ",
            <br key={1} />,
            "For $39 a month, you'll help that child and other vulnerable children in their community to stand tall, free from poverty.",
          ]}
        />
      );
    } else {
      return false;
    }
  }

  handleResize() {
    let mqlLarge = window.matchMedia(this.state.desktop);
    let mqlMedium = window.matchMedia(this.state.tablet);
    let mqlSmall = window.matchMedia(this.state.mobile);
    mqlLarge.addListener(() => {
      this.handleWindowSizeChange(mqlLarge, "desktop");
      removeBodyClass("search-takeover");
    });
    mqlMedium.addListener(() => {
      this.handleWindowSizeChange(mqlMedium, "tablet");
    });
    mqlSmall.addListener(() => {
      this.handleWindowSizeChange(mqlSmall, "mobile");
    });

    // if (mediaQuery.matches) {
    //   this.setState({ device: "desktop" });
    // } else {
    //   this.setState({ device: "mobile" });
    // }
  }

  handleWindowSizeChange(mql, size) {
    if (mql.matches) {
      this.setState({ device: size });
    }
  }

  calculateGrid(childrenGrid) {
    const grid = childrenGrid;
    const rowHeight = parseInt(window.getComputedStyle(grid).getPropertyValue("grid-auto-rows"));
    const rowGap = parseInt(window.getComputedStyle(grid).getPropertyValue("grid-row-gap"));
    const rowSpanRatio = rowHeight + rowGap;
    this.setState({
      gridVars: {
        rowGap: rowGap,
        rowSpanRatio: rowSpanRatio,
        tileHeight: rowSpanRatio,
      },
      gridVarsReceived: true,
    });
  }

  resetGridCalc() {
    this.setState({ gridVarsReceived: false });
  }

  toggleDetailView(bool) {
    this.setState({
      singleChildView: bool,
    });
  }

  toggleErrorMessage(bool, props) {
    this.setState({
      showDeepLinkError: bool,
      message: props,
    });
  }

  render() {
    // console.log(this.props.status);
    return (
      <div className="sponsorship-rcds">
        <ViewChooser
          renderHeader={this.renderHeader}
          renderShowMore={this.renderShowMore}
          resetShowMore={this.resetShowMore}
          resetGridCalc={this.resetGridCalc}
          calculateGrid={this.calculateGrid}
          searchMethodSelector={this.searchMethodSelector}
          setSelectedValue={this.setSelectedValue}
          lastSearchKey={this.lastSearchKey}
          resetFiltersDisabled={this.state.resetFiltersDisabled}
          enableClearAll={this.enableClearAll}
          updatelastSearchKeyStatus={this.updatelastSearchKeyStatus}
          setToolTip={this.setToolTip}
          changeView={this.handleChildDetailClick}
          device={this.state.device}
          showMore={this.showMore}
          gridVars={this.state.gridVars}
          gridVarsReceived={this.state.gridVarsReceived}
          handleHistory={this.handleHistory}
          setGridWasActive={this.setGridWasActive}
          lastSearchKeyObj={this.state.lastSearchKeyObj}
          descriptorsReceived={this.state.descriptorsReceived}
          descriptorIndex={this.state.descriptorIndex}
          descriptorIndexArray={this.state.descriptorIndexArray}
          childId={this.state.childId}
          handleBackButton={this.handleBackButton}
          sponsorshipMonthlyPrice={this.state.sponsorshipMonthlyPrice}
          backLink={this.state.backLink}
          singleChildView={this.state.singleChildView}
          handleChildDetailClick={this.handleChildDetailClick}
          fireAnalyticsEvents={this.fireAnalyticsEvents}
          toggleDetailView={this.toggleDetailView}
          toggleErrorMessage={this.toggleErrorMessage}
          checkChildLocked={this.checkChildLocked}
          animateGrid={this.animateGrid}
          setADPStatus={this.setADPStatus}
          {...this.state}
          {...this.props}
        />
      </div>
    );
  }
}

function mapStateToProps(state) {
  // console.log("map state to props", state);
  return {
    ...state,
    //request: state.receiveRandomChild,
  };
}

//Get actions and pass them as props
function matchDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      statusUpdater: statusUpdater,
      getDescriptors: getDescriptors,
    },
    dispatch
  );
}

export default connect(mapStateToProps, matchDispatchToProps)(App);
